import PropTypes from 'prop-types'
import { AddToCalendarButton } from './styled-components'
import { useTranslation } from 'react-i18next'
import IconGoogleCalendar from '@/shared/icons/NewDesign/IconGoogleCalendar'

const ScheduleCalendarButton = ({googleCalendarUrl}) => {
  const { t } = useTranslation()

  if (!googleCalendarUrl) return

  return (
    <AddToCalendarButton
      href={googleCalendarUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('subscriptionTools:schedule_callback.add_to_google_calendar')}
      title={t('subscriptionTools:schedule_callback.add_to_google_calendar')}
    >
      <IconGoogleCalendar size={32} />
      {t('subscriptionTools:schedule_callback.add_to_google_calendar')}
    </AddToCalendarButton>
  )
}

ScheduleCalendarButton.propTypes = {
  googleCalendarUrl: PropTypes.string,
}

export default ScheduleCalendarButton
